<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td>Группа</td>
            <td>Вид</td>
            <td>Количество, шт.</td>
            <td>Описание</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in project.DIGITAL_SOLUTION.items">
            <DigitalSolutionList
              :item="item"
              :index="index"
              v-bind:key="index"
            ></DigitalSolutionList>
          </template>
        </tbody>
      </table>
      <div class="add-row" v-show="!$parent.$parent.projectDisabled">
        <a class="link-add-row" v-on:click="addItem">Добавить решение</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import DigitalSolutionList from "@/components/project/form/lists/DigitalSolutionList";

export default {
  name: "digital_solution",
  props: ["project"],
  components: {
    DigitalSolutionList
  },
  methods: {
    hasError(col, field) {
      if (
        typeof this.$parent.$parent.digitalSolutionsErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.digitalSolutionsErrors[col][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    errorText(col, field) {
      if (
        typeof this.$parent.$parent.digitalSolutionsErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.digitalSolutionsErrors[col][field] !==
          "undefined"
        ) {
          return this.$parent.$parent.digitalSolutionsErrors[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (
        typeof this.$parent.$parent.digitalSolutionsErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.digitalSolutionsErrors[col][field] !==
          "undefined"
        ) {
          Vue.delete(this.$parent.$parent.digitalSolutionsErrors[col], field);
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.project.DIGITAL_SOLUTION === "undefined") {
        this.project.DIGITAL_SOLUTION = {
          items: []
        };
      }
      this.project.DIGITAL_SOLUTION.items.push({});
    },

    deleteItem(index) {
      this.project.DIGITAL_SOLUTION.items.splice(index, 1);
    }
  }
};
</script>

<style scoped></style>
